module.exports = __webpack_public_path__ + "static/lead-notifications-901a70fee3b3c17c0d72efc8e6f9d0e3.png";